import React, { useContext } from "react";

import { Select } from "../../components/ui";
import { SettingsContext } from "../../contexts";
import { LookbookFilterDropdown } from "../components/lookbook";

const currentYear = new Date().getFullYear();
const startYear = 1975;

// ui Select with the old react-dropdown contract the handlers below expect: onChange
// receives the whole option ({ value, label }). The stored year is a string while
// its option value is a number, so the selected option is matched by string.
function FilterSelect({ onChange, options, value, placeholder, className }) {
  const selected = options.find((o) => o.value != null && String(o.value) === String(value));
  return (
    <Select
      options={options}
      value={selected ? selected.value : null}
      placeholder={placeholder}
      label={placeholder}
      className={className}
      fullWidth
      onChange={(next, option) => onChange(option ?? { value: next })}
    />
  );
}

export function ListingsFilters({
  sort,
  setSort,
  filter,
  setFilter,
  inStock,
  setInStock,
  isYearFilter = false,
  isConditionFilter = false,
  stacked = false,
}) {
  const { isMerchant } = useContext(SettingsContext);

  const statusFilterOptions = [
    { value: "active", label: "Active" },
    { value: "deactivated", label: "Inactive" },
    ...(isMerchant
      ? []
      : [
          { value: "reserved", label: "Reserved" },
          { value: "deposit", label: "With Deposit" },
        ]),
  ];

  const yearFilterOptions = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => ({ value: currentYear - i, label: currentYear - i })
  );

  const conditionFilterOptions = [
    { value: "new", label: "New" },
    { value: "excellent", label: "Excellent" },
    { value: "very-good", label: "Very Good" },
    { value: "good", label: "Good" },
    { value: "fair", label: "Fair" },
  ];

  const onStatusChange = (v) => {
    if (v.value) {
      setFilter({ ...filter, status: [v.value] });
    } else {
      const { status, ...updatedFilter } = filter;
      setFilter(updatedFilter);
    }
  };

  const onYearChange = (v) => {
    if (v.value) {
      setFilter({ ...filter, year: [String(v.value)] });
    } else {
      const { year, ...updatedFilter } = filter;
      setFilter(updatedFilter);
    }
  };

  const onConditionChange = (v) => {
    if (v.value) {
      setFilter({ ...filter, condition: [v.value] });
    } else {
      const { condition, ...updatedFilter } = filter;
      setFilter(updatedFilter);
    }
  };

  if (filter) {
    if (filter.status) {
      statusFilterOptions.unshift({ value: null, label: "Show all" });
    }
    if (filter.year) {
      yearFilterOptions.unshift({ value: null, label: "Show all" });
    }
    if (filter.condition) {
      conditionFilterOptions.unshift({ value: null, label: "Show all" });
    }
  }

  const Dropdown = stacked ? LookbookFilterDropdown : FilterSelect;

  const sortOptions = [
    { value: "refreshed_at|desc", label: "Recently updated" },
    { value: "price|asc", label: "Price: Low To High" },
    { value: "price|desc", label: "Price: High To Low" },
    { value: "created_at|desc", label: "Creation date" },
    { value: "brand_name|asc", label: "Brand" },
  ];


  return (
    <div
      className={
        stacked
          ? "lb-select-listings__filters"
          : "d-flex flex-column flex-md-row justify-content-start list-toolbar sort-dropdowns align-items-center w-50"
      }
    >
      <div className={stacked ? undefined : "w-100 p-2"}>
        <Dropdown
          onChange={(v) => setSort(v.value)}
          options={sortOptions}
          placeholder="Recently updated"
          value={sort}
        />
      </div>
      <div className={stacked ? undefined : "w-100 p-2"}>
        <Dropdown
          onChange={onStatusChange}
          options={statusFilterOptions}
          placeholder="Filter by status"
          value={filter?.status?.[0] || null}
        />
      </div>
      {isYearFilter && (
        <div className={stacked ? undefined : "w-100 p-2"}>
          <Dropdown
            onChange={onYearChange}
            options={yearFilterOptions}
            placeholder="Filter by year"
            value={filter?.year?.[0] || null}
          />
        </div>
      )}
      {isConditionFilter && (
        <div className={stacked ? undefined : "w-100 p-2"}>
          <Dropdown
            onChange={onConditionChange}
            options={conditionFilterOptions}
            placeholder="Filter by condition"
            value={filter?.condition?.[0] || null}
          />
        </div>
      )}
    </div>
  );
}
